import React, { useState } from "react";
import { Button, Card, Icon, Loader, Radio, Tab } from "semantic-ui-react";
import styles from "./styles.module.css";
import { useNavigate } from "react-router-dom";
import { ReactComponent as EasyReturnSvg } from "../../../assets/easyreturn.svg";
import { ReactComponent as ShippingLocationSvg } from "../../../assets/shippingLocation.svg";
import { ReactComponent as PlaySvg } from "../../../assets/play.svg";
import { ReactComponent as PlayRedSvg } from "../../../assets/playred.svg";

const ShippingIndex = () => {
  const [modal, setModal] = useState("");
  const navigate = useNavigate();
  return (
    <div className={styles.page}>
      <div className={styles.header}>Vendor Fulfilment </div>
      <div className={styles.info}>
        You can actually set your preferred pickup location or return location
        for your customers for every region or state. You can also set the price
        per kilogram of each item.
      </div>
      <div className={styles.cards}>
        <div className={styles.card1}>
          <EasyReturnSvg />
          <div>Preferred Return Location</div>
          <div className={styles.smalltext}>
            Kindly set preferred location where your goods can be returned in
            case of any defect
          </div>
          <div>
            {" "}
            <Button
              positive
              className={styles.positive}
              onClick={() => navigate("/vendor/shipping/returnlocationlist")}
            >
              <div className={styles.button}>
                <span>Continue</span>
                <PlaySvg />
              </div>
            </Button>
          </div>
        </div>
        <div className={styles.card2}>
          <ShippingLocationSvg />
          <div>Shipping By Region/State</div>
          <div className={styles.smalltext2}>
            You can choose the price of shipping from the states you are located
            to the customers
          </div>
          <div>
            {" "}
            <Button
              negative
              className={styles.negative}
              onClick={() => navigate("/vendor/shipping/shippinglocationprice")}
            >
              <div className={styles.button}>
                <span>Set Shipping Fee</span>
                <PlayRedSvg />
              </div>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingIndex;
